<template>
  <div>


    <div class="wrapper wrapper-full-page login-wrapper">
      <div class="full-page login-page" data-color=""
           data-image="static/img/background/background-2.jpg">
        <!--   you can change the color of the filter page using: data-color="blue | azure | green | orange | red | purple" -->
        <div class="content">
          <div class="container">
            <!-- <div class="row"> -->
              <div class="login-box">
                <form @submit.prevent="login({ email, password })">
                  <div class="" data-background="color" data-color="blue">
                    <div class="card-header text-center">
                      <a href="//taptasty.com"><img src="/static/img/logo-taptasty.png" class="logo"></a>
                    </div>
                    <div class="card-content">
                      <p class="text-danger" v-show="errors.has('error')">
                        {{ getError('error') }}
                      </p>
                      <div class="form-group">
                        <!-- <label>Email address</label> -->
                        <input type="email"
                                name="email"
                                placeholder="Email*"
                                class="form-control "
                                v-model="model.email"
                                v-validate="modelValidations.email">
                        <small class="text-danger" v-show="errors.has('email')">
                          {{ getError('email') }}
                        </small>
                      </div>
                      <div class="form-group">
                        <!-- <label>Password</label> -->
                        <input type="password"
                                name="password"
                                placeholder="Password*"
                                class="form-control"
                                v-model="model.password"
                                v-validate="modelValidations.password">
                        <small class="text-danger" v-show="errors.has('password')">
                          {{ getError('password') }}
                        </small>
                      </div>
                    </div>
                    <div class="card-footer text-center">
                      <button type="submit"  @click.prevent="validate"  class="btn btn-orange-purple btn-fill btn-wd ">LOG IN</button>
                      <div class="forgot">
                        <router-link to="/recover">
                          Forgot your password?
                        </router-link>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            <!-- </div> -->
          </div>
        </div>

<!--         <footer class="footer footer-transparent">
          <div class="container">
            <div class="copyright">
              &copy; Coded with
              <i class="fa fa-heart heart"></i> by
              <a href="http://11digits.com" target="_blank">11Digits</a>
            </div>
          </div>
        </footer> -->
        <div class="full-page-background" ></div>
      </div>
    </div>
    <div class="collapse navbar-collapse off-canvas-sidebar">
      <ul class="nav nav-mobile-menu">
        <router-link to="/register" tag="li">
          <a>Register</a>
        </router-link>
        <router-link to="/admin/overview" tag="li">
          <a>Dashboard</a>
        </router-link>
      </ul>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import Vuex from 'vuex'
  import {mapFields} from 'vee-validate'
  Vue.use(Vuex)

  export default {
    data () {
      return {
        model: {
          email: '',
          password: '',
          company_id: 8
        },
        modelValidations: {
          email: {
            required: true,
            email: true,
            min: 4
          },
          password: {
            required: true,
            min: 6
          }
        }
      }
    },
    computed: {
      ...mapFields(['email', 'password'])
    },
    methods: {
      toggleNavbar () {
        document.body.classList.toggle('nav-open')
      },
      closeMenu () {
        document.body.classList.remove('nav-open')
        document.body.classList.remove('off-canvas-sidebar')
      },
      getError (fieldName) {
        // console.warn(this.errors)
        return this.errors.first(fieldName)
      },
      validate () {
        this.$validator.validateAll().then(isValid => {
          this.login()
          // this.$emit('on-submit', this.registerForm, isValid)
        })
      },
      login () {
        var self = this
        var creds = {
          email: this.model.email,
          password: this.model.password
          // company_id: this.model.company_id
        }
        // console.warn(self.$session)
        this.apiRequest('/auth', 'POST', creds, function (response) {
          if (response.status === true) {
            // var userData = { token: '', user: {} }
            // first check if the user is owner for at least one company
            var usersCompanies = []
            var hasCompany = false
            var companies = response.data.user.companies
            for (var key in companies) {
              if (companies[key].role === 'MARKETER' || companies[key].role === 'OPERATOR' || companies[key].role === 'OWNER' || companies[key].role === 'USER' || companies[key].role === 'LOCATION_ADMIN' || companies[key].role === 'USER_CUSTOM' || companies[key].role === 'LOCATION_STORE_ADMIN') {
                usersCompanies.push(companies[key])
                hasCompany = true
              }
            }

            if (!hasCompany) {
              self.errors.add('email', 'Failed to login, please try again.')
            } else {
              self.$session.start()
              self.$session.set('token', response.data.token)
              if (usersCompanies[0].id) {
                self.$session.set('selectedCompany', usersCompanies[0].id)
                self.$session.set('selectedCompanyData', self.buildCompanySessionData(usersCompanies[0], {}))
                self.$session.set('companyName', usersCompanies[0].name)
                self.$session.set('companyAvatar', response.data.user.avatar)
              } else {
                self.$session.set('selectedCompany', null)
                self.$session.set('selectedCompanyData', null)
                self.$session.set('companyName', null)
                self.$session.set('companyAvatar', null)
                self.$session.set('companyAvatar', null)
              }

              self.$cookie.set('filter-locations', '')

              self.$session.set('userData', JSON.stringify(response.data.user))
              self.$session.set('userDataLocations', JSON.stringify(response.data.user.locations))
              self.$session.set('userDataRole', response.data.user.role)
              self.$i18n.locale = response.data.user.language
              self.initAuditClient()

              const selectedCompanyId = usersCompanies[0].id
              self.apiRequest('/listdefaults', 'GET', {token: response.data.token, company_id: selectedCompanyId}, function (response2) {
                if (response2.status === true) {
                  self.$session.set('defaultData', response2.data[0])
                  const companyData = self.$session.get('selectedCompanyData') || {}
                  companyData.has_charisma_location = !!response2.data[0].has_charisma_location
                  companyData.has_nexus_location = !!response2.data[0].has_nexus_location
                  self.$session.set('selectedCompanyData', companyData)
                }
                self.initAuditClient()
                if (self.$session.get('userDataRole') === 'USER') {
                  self.$router.push('/orders')
                } else {
                  if (self.$session.get('userDataRole') === 'MARKETER') {
                    self.$router.push('/products')
                  } else {
                    self.$router.push('/')
                  }
                }
              })
            }
          } else {
            // handle errors
            // console.warn(response.errors)
            for (var prop in response.errors) {
              if (response.errors.hasOwnProperty(prop)) {
                // console.warn(prop)
                self.errors.add({ field: prop, msg: response.errors[prop] })
              }
            }
          }
        })
      }
    },
    beforeDestroy () {
      this.closeMenu()
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/Login.vue